import {
	createBaseThemeOptions,
	createUnifiedTheme,
	genPageTheme,
	palettes,
	shapes,
} from '@backstage/theme';

export const zestTheme = createUnifiedTheme({
	...createBaseThemeOptions({
		palette: {
			...palettes.light,
			primary: {
				main: '#003B6F',
			},
			secondary: {
				main: '#009B9D',
			},
			error: {
				main: '#C44536',
			},
			warning: {
				main: '#C88719',
			},
			info: {
				main: '#2878A8',
			},
			success: {
				main: '#79B82A',
			},
			background: {
				default: '#F4F7FA',
				paper: '#FFFFFF',
			},
			banner: {
				info: '#2878A8',
				error: '#C44536',
				text: '#102A43',
				link: '#003B6F',
			},
			errorBackground: '#FBEAE7',
			warningBackground: '#FFF4D6',
			infoBackground: '#E3F2F5',
			navigation: {
				background: '#003B6F',
				indicator: '#79B82A',
				color: '#D9F0F0',
				selectedColor: '#FFFFFF',
			},
		},
	}),
	defaultPageTheme: 'home',
	pageTheme: {
		home: genPageTheme({ colors: ['#009B9D', '#003B6F'], shape: shapes.wave }),
		documentation: genPageTheme({
			colors: ['#2878A8', '#003B6F'],
			shape: shapes.wave2,
		}),
		tool: genPageTheme({ colors: ['#79B82A', '#003B6F'], shape: shapes.round }),
		service: genPageTheme({
			colors: ['#009B9D', '#003B6F'],
			shape: shapes.wave,
		}),
		website: genPageTheme({
			colors: ['#2878A8', '#003B6F'],
			shape: shapes.wave,
		}),
		library: genPageTheme({
			colors: ['#79B82A', '#003B6F'],
			shape: shapes.wave,
		}),
		other: genPageTheme({ colors: ['#009B9D', '#003B6F'], shape: shapes.wave }),
		app: genPageTheme({ colors: ['#2878A8', '#003B6F'], shape: shapes.wave }),
		apis: genPageTheme({ colors: ['#79B82A', '#003B6F'], shape: shapes.wave }),
	},
});